import { render, staticRenderFns } from "./MpcNode.vue?vue&type=template&id=5f61add4&scoped=true"
import script from "./MpcNode.vue?vue&type=script&lang=js"
export * from "./MpcNode.vue?vue&type=script&lang=js"
import style0 from "./MpcNode.vue?vue&type=style&index=0&id=5f61add4&prod&lang=less"
import style1 from "./MpcNode.vue?vue&type=style&index=1&id=5f61add4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f61add4",
  null
  
)

export default component.exports